<template>
  <div class="min-w-48">
    <div>#{{ props.id }}</div>

    <div class="my-2 flex justify-between">
      <div>
        <FontAwesomeIcon icon="fa-regular fa-user-headset" size="xl" />
        {{ props.internKommentar.createdBy }}
      </div>
      <div>{{ formatStandardDate(props.internKommentar.createdAt) }}</div>
    </div>
    <div>{{ pureBody }}</div>
  </div>
</template>
<script setup lang="ts">
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUserHeadset } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import DOMPurify from "dompurify";

import { formatStandardDate } from "@/common/formatters";
import type { IInternKommentar } from "@/composables/KundserviceAppApiClient";

const props = defineProps<{ internKommentar: IInternKommentar; id: number }>();

const pureBody = DOMPurify.sanitize(props.internKommentar.body, {
  ALLOWED_TAGS: [],
  ALLOWED_ATTR: [],
});

library.add(faUserHeadset);
</script>
